import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { styles } from "./pd-order-agreement.styles.js";
import { LitElement, html } from "lit";
import { property, query } from "lit/decorators.js";
import { localized, msg } from "@lit/localize";
import "@progressive-development/pd-forms/pd-checkbox";
import "@progressive-development/pd-forms/pd-form-container";
import "@progressive-development/pd-forms/pd-form-row";
import "@progressive-development/pd-dialog/pd-popup";
//#region src/pd-order-agreement/PdOrderAgreement.ts
var PdOrderAgreement = class PdOrderAgreement extends LitElement {
	constructor(..._args) {
		super(..._args);
		this.required = true;
		this.agreed = false;
	}
	static {
		this.styles = [styles];
	}
	render() {
		return html`
      <pd-form-container id="agreementFormId">
        <pd-form-row>
          <pd-checkbox
            id="agreeConditionsId"
            valueName="agreeId"
            class="agree-box"
            ?required="${this.required}"
            requiredMsg="${msg("Bitte stimmen Sie den Allgemeinen Geschäftsbedingungen zu, um fortzufahren.", { id: "pd.order.summary.agree.required" })}"
            @pd-form-element-change="${this._onCheckboxChange}"
          >
            ${msg("Ich akzeptiere die", { id: "pd.order.summary.agree.link1" })}
            <a
              @click="${this._openTermsAndConditions}"
              @keypress="${this._openTermsAndConditions}"
              >${msg("Allgemeinen Geschäftsbedingungen", { id: "pd.order.summary.agree.link2" })}</a
            >
          </pd-checkbox>
        </pd-form-row>
      </pd-form-container>

      <pd-popup id="agreePopupId">
        <slot name="legal"></slot>
      </pd-popup>
    `;
	}
	/** Whether the agreement is valid (not required, or checkbox is checked). */
	get valid() {
		return !this.required || this._agreeForm?.valid === true;
	}
	/** Triggers form validation and returns validity state. */
	async triggerValidate() {
		return this._agreeForm?.triggerValidate();
	}
	_onCheckboxChange(e) {
		const parsedValue = e.detail?.parsedValue;
		this.agreed = parsedValue === true;
		this.dispatchEvent(new CustomEvent("pd-agreement-change", {
			detail: { agreed: this.agreed },
			bubbles: true,
			composed: true
		}));
	}
	_openTermsAndConditions(e) {
		e.stopPropagation();
		this._agreePopup?.showPopup();
	}
};
__decorate([property({ type: Boolean })], PdOrderAgreement.prototype, "required", void 0);
__decorate([property({
	type: Boolean,
	reflect: true
})], PdOrderAgreement.prototype, "agreed", void 0);
__decorate([query("#agreementFormId")], PdOrderAgreement.prototype, "_agreeForm", void 0);
__decorate([query("#agreePopupId")], PdOrderAgreement.prototype, "_agreePopup", void 0);
PdOrderAgreement = __decorate([localized()], PdOrderAgreement);
//#endregion
export { PdOrderAgreement };
